import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a816kjydgp: FaireBrandEntity = {
  token: "b_a816kjydgp",
  type: "brand",
  name: "Casa Bosques",
  avatarUrl: "https://cdn.faire.com/fastly/f8d35214384d0cddc7711e8e5047d8a681ec72ecb1c2c682d77eebd47512c376.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/0c3d3d5e07d2f045fbd0fb530c84ebcc59678111fba895a326ec467f9612f085.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/f8d35214384d0cddc7711e8e5047d8a681ec72ecb1c2c682d77eebd47512c376.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/0c3d3d5e07d2f045fbd0fb530c84ebcc59678111fba895a326ec467f9612f085.jpeg",
  location: "NYC, NY, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 18,
  isInsider: true,
  description: "Casa Bosques is a chocolate-making company devoted to exploring the history, methods, origins, and culture of chocolate. \nEach season, it releases its own chocolate collections, while also featuring a special collaboration. Sourced from small ranches throughout México—primarily in Chiapas and Tabasco—Casa Bosques works with rare and special cacao varieties, including white Criollo and Trinitario beans. Single origin, organic, and fair trade, these beans are carefully nurtured from tree to bar, allowing close involvement at every step. Casa Bosques crafts chocolate with the same care as the farmers who cultivate and harvest each heirloom bean",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:03.340Z",
    importedBy: "entity-db-cli"
  }
};
